import { Api } from "./api"

export class ProducerApi extends Api {
  constructor() {
    super('producers', [])
  }
}
